import { FC, useCallback } from "react";

import Stack from "@mui/material/Stack";
import * as QrCode from "qrcode";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

const PREVIEW_QR_DUMMY_URL = "https://zeffy.com";
const PREVIEW_QR_SIZE = 73;

export const PrintableAuctionQrCard: FC = () => {
  const { t } = useTranslate();

  const handleCanvasRef = useCallback((canvas: HTMLCanvasElement | null) => {
    if (!canvas) {
      return;
    }
    QrCode.toCanvas(canvas, PREVIEW_QR_DUMMY_URL, {
      width: PREVIEW_QR_SIZE,
      margin: 0,
    });
  }, []);

  return (
    <Stack
      alignItems="center"
      sx={(theme) => ({
        width: 96,
        backgroundColor: theme.palette.surface.neutral.white,
        borderRadius: "4px",
        border: `0.5px solid ${theme.palette.border.neutral.moderate}`,
      })}
    >
      <Stack alignItems="center" gap="4px" sx={{ padding: "12px 12px 12px 12px" }}>
        <canvas ref={handleCanvasRef} width={PREVIEW_QR_SIZE} height={PREVIEW_QR_SIZE} />
        <Stack alignItems="center" gap="4px" sx={{ width: "100%" }}>
          <DashboardTypography
            variant="caption"
            vibe="text-neutral-intense"
            fontWeight={600}
            sx={{ fontSize: "5.8px", lineHeight: "7.8px", textAlign: "center" }}
          >
            {t("common", "shareFormModal.qrCode.items.previewCard.exampleItem")}
          </DashboardTypography>
          <Stack sx={{ width: "100%", textAlign: "center" }}>
            <DashboardTypography
              variant="caption"
              vibe="text-neutral-intense"
              fontWeight={600}
              sx={{ fontSize: "3.9px", lineHeight: "5.8px" }}
            >
              {t("common", "shareFormModal.qrCode.items.previewCard.startingBid")}
            </DashboardTypography>
            <DashboardTypography
              variant="caption"
              vibe="text-neutral-intense"
              fontWeight={600}
              sx={{ fontSize: "3.9px", lineHeight: "5.8px" }}
            >
              {t("common", "shareFormModal.qrCode.items.previewCard.minimumBidIncrement")}
            </DashboardTypography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
